import React from "react";
import RichNavigationMenu from "../../ui/navigation-menu-06";
import { useAppNav } from "../hooks/useAppNav";

const Navigation: React.FC = () => {
  const { shouldHideNavigation, desktopMenuItems } = useAppNav();

  if (shouldHideNavigation) return null;

  return (
    <div className="hidden min-w-0 items-center lg:flex">
      <RichNavigationMenu items={desktopMenuItems} />
    </div>
  );
};

export default Navigation;
